import { mapKeys } from 'lodash-es'

export const SCHEDULED = 'SCHEDULED'
export const IN_PROGRESS = 'IN_PROGRESS'
export const PASSED = 'PASSED'
export const FAILED = 'FAILED'

export const SCRAPING_SESSION_STATUSES = mapKeys(
  [
    { name: 'Scheduled', value: SCHEDULED },
    { name: 'In progress', value: IN_PROGRESS },
    { name: 'Passed', value: PASSED },
    { name: 'Failed', value: FAILED },
  ],
  'value',
)
